export default class Objectfit {
	constructor(element: HTMLElement) {

		const img: HTMLElement = element.querySelector("img") as HTMLElement;

		img.style.display = 'none';
		element.setAttribute('style', `background-image: url('${img.getAttribute('src')}'); background-size: cover`);
	}
}
